<template lang="pug">
  component(:is="flaggedComponent" v-bind="$props" v-on="$attrs")
</template>

<script>
import DialogsOld from './DialogsOld.vue';
import DialogsNew from './DialogsNew.vue';
import { mapState } from 'vuex';

export default {
  name: 'DialogsWrapper',
  components: {
    DialogsOld,
    DialogsNew,
  },
  computed: {
    ...mapState({
      featureFlags: state => state.featureFlags.FEATURE_FLAGS,
    }),
    flaggedComponent() {
      return this.featureFlags?.SHOW_NEW_DIALOG_DESIGN ? DialogsNew : DialogsOld;
    },
  },
};
</script>
